const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const updateAffiliatorAccountApi = async (userData) => {
  const token = localStorage.getItem("token");

  if (!token) {
    console.error('[updateAffiliatorAccountApi] Ошибка: Токен авторизации не найден.');
    // throw new Error("Токен авторизации не найден."); 
  }

  try {
    const response = await fetch(`${API_BASE_URL}/affiliator/user/my-account`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('[updateAffiliatorAccountApi] Ошибка обновления данных аккаунта аффилиата:', errorData);
      throw { ...errorData, statusCode: response.status };
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('[updateAffiliatorAccountApi] Ошибка сети или другая ошибка при обновлении данных аккаунта аффилиата:', error);
    throw error;
  }
};